<template>
  <div>
    <div v-if="$route.name === 'gradeDetail'" class="main-body">
      <!-- <a-card class="workplace_card"> -->
      <div class="content">
        <div class="list-item pr-7">
          <div class="d-flex">
            <div class="font-20 font-bold">{{ list ? list.planclassesName : "" }}</div>
          </div>
          <div class="d-flex progress">
            <div class="mr-1">已学 {{ list.progress ? list.progress : "0" }}%</div>
            <a-progress class="flex-1" :percent="list.progress" status="active" :showInfo="false" />
          </div>
          <div class="d-flex" v-if="list.lastSchedule && list.lastSchedule.scheduleName">
            <div class="text-cut">学习至：{{ list.lastSchedule.scheduleName }}</div>
          </div>
          <div class="d-flex justify-between" v-if="list.lastSchedule && list.lastSchedule.scheduleName">
            <div class="d-flex">
              <div>教学团队：</div>
              <div class="d-flex" v-for="item in list.teacherList" :key="item.id">
                <img class="icon-img ml-1" :src="item.avatar" alt="" v-if="item" />
              </div>
            </div>
          </div>
          <div class="d-flex justify-between">
            <div class="d-flex">
              <div @click="toLiveCalendar" class="d-flex mr-2 cp">
                <img class="icon-img mr-1" :src="kebiao" alt="" />
                直播课表
              </div>
              <div class="d-flex mr-2" v-if="list.totalExamNum">
                <img class="icon-img mr-1" :src="zuoye" alt="" />
                <div class="mr-1">作业</div>
                <div>{{ list.examNum }}</div>
              </div>
              <div class="d-flex mr-2">
                <img class="icon-img mr-1" :src="wenda" alt="" />
                <div class="mr-1">问题</div>
                <div>{{ list.qaNum }}</div>
              </div>
            </div>
            <div class="pr-4" v-if="list.liveScheduleList && list.liveScheduleList.length">
              <a-button type="primary" @click="toLivePlay(list)">
                <div class="d-flex">
                  正在直播
                  <img class="living-icon ml-1" :src="livingIcon" alt="" />
                </div>
              </a-button>
              <div class="d-flex mt-4">
                <div>直播课次：</div>
                <div>{{ list.liveScheduleList[0].scheduleName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="list">
        <a-tabs default-active-key="1">
          <a-tab-pane tab="概览" key="1">
            <div class="d-flex mt-4">
              <div class="bar-title">排序:</div>
              <div class="tabs d-flex">
                <span
                  @click="sortTabsChange(item)"
                  class="tab-item mx-2"
                  :class="activeSortTab === item.value ? 'tab-item-acitve' : ''"
                  :key="item.value"
                  v-for="item in sortTabs"
                >{{ item.label }}</span
                >
              </div>
            </div>
            <div v-for="(item, index) in list.subjectList" :key="index">
              <div class="mt-4" style="display: inline-block; width: 100%">
                <div class="d-flex mb-4">
                  <!-- <div class="line mt-4 mb-4"></div> -->
                  <img class="icon-img mr-1" :src="decorate" alt="" />
                  <span class="font-16 font-bold">{{ item.subjectName }}</span>
                </div>
                <a-list :grid="{ gutter: 16, column: 2 }">
                  <a-list-item v-for="i in item.classesList" :key="i.id">
                    <div class="d-flex" style="height:190px">
                      <div
                        class="list-content px-2"
                        style="width:100%"
                        v-if="i.classesProp === '1' || i.classesProp === '0'"
                      >
                        <div class="list-item mb-3 d-flex">
                          <div class="img mr-2">
                            <img style="width: 195px;" :src="i.cover" alt="" />
                          </div>
                          <div>
                            <div class="d-flex">
                              <span
                                v-if="i.lastStudy"
                                class="course-badge nearly ml-1"
                              >最近在学</span>
                              <div class="font-20 font-bold text-cut" style="width: 280px;">{{ i.className }}</div>
                            </div>
                            <div class="d-flex justify-between mt-2">
                              <div class="d-flex">
                                <div>授课老师：</div>
                                <div class="d-flex">
                                  <!-- <div class="img-wrapper"></div> -->
                                  <div class="d-flex">
                                    <img class="icon-img ml-1" :src="i.teacher.avatar" alt="" v-if="i.teacher" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="d-flex mt-2">
                              <div style="width: 319px;" class="text-cut">上次学到：{{ i.lastSchedule ? i.lastSchedule.scheduleName : '' }}</div>
                            <!-- <div class="text-cut-2">上次学到：{{ i.lastSchedule ? i.lastSchedule.scheduleName : '' }}</div> -->
                            <!-- <div class="text-cut-2">上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：次学到：上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：上次学到：</div> -->
                            </div>
                            <div class="d-flex justify-end mt-2 mr-2">
                              <div>
                                <a-button
                                  type="primary"
                                  @click="toLivePlay(i)"
                                  v-if="i.liveScheduleList.length > 0"
                                >
                                  <div class="d-flex">
                                    正在直播
                                    <img class="living-icon ml-1" :src="livingIcon" alt="" />
                                  </div>
                                </a-button>
                                <a-button type="primary" class="ml-4" v-if="!i.lastSchedule || !i.lastSchedule.lastWatchTime" @click="goToClassDetail(i, '1')">
                                  开始学习
                                </a-button>
                                <a-button type="primary" class="ml-4" v-if="i.lastSchedule && i.lastSchedule.lastWatchTime" @click="goToClassDetail(i, '1')">
                                  继续学习
                                </a-button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="list-content" style="width: 95%;margin-left:20px" v-else>
                        <div class="list-item mb-3 d-flex">
                          <div class="img mr-2">
                            <img style="width: 195px;" :src="i.cover" alt="" />
                          </div>
                          <div>
                            <div class="d-flex">
                              <div class="font-20 font-bold">{{ i.className }}</div>
                            </div>
                            <div class="d-flex justify-between mt-2">
                              <div>
                                <a-button type="primary" class="ml-4" @click="goToClassMock(i)">
                                  开始学习
                                </a-button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div> -->
                  </a-list-item>
                </a-list>
              </div>
              <!-- </div> -->
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <router-view v-else />
  </div>
</template>
<script>

import { studentPlanclasses } from '@/api/myClass'
// import { StarOutlined, LikeOutlined, MessageOutlined } from '@ant-design/icons-vue'
import Vue from 'vue'
import { goToLivePlayer } from '@/utils/livePlay'
import kebiao from '@/assets/icons/kebiao.png'
import zuoye from '@/assets/icons/zuoye.png'
import wenda from '@/assets/icons/wenda.png'
import decorate from '@/assets/icons/装饰@3x.png'
import livingIcon from '@/assets/icons/living.gif'
// import { mapState } from 'vuex'

export default {
  name: 'GradeDetail',
  components: {
    // StarOutlined,
    // LikeOutlined,
    // MessageOutlined,
  },
  props: {
    planClassesId: {
      type: String,
      default: '0'
    }
  },
  computed: {
    // ...mapState({
    //   planclassesId: state => state.course.planclassesId
    // })
  },
  data() {
    return {
      kebiao,
      zuoye,
      wenda,
      livingIcon,
      decorate,
      data: [
        {
          title: 'Title 1',
        },
        {
          title: 'Title 2',
        },
        {
          title: 'Title 3',
        },
        {
          title: 'Title 4',
        },
        {
          title: 'Title 5',
        },
        {
          title: 'Title 6',
        },
      ],
      activeSortTab: 1,
      sortTabs: [
        {
          label: '默认',
          value: 1,
        },
        {
          label: '最近学习',
          value: 2,
        },
      ],
      list: {
        planclassesName: '',
      },
    }
  },
  created() {
    // console.log('created', this.$route)
    if (this.$route.query.planclassesId) {
      this.planclassesId = this.$route.query.planclassesId
    }
    console.log('tag', this.planclassesId)
    if (this.$route.query.planclassesName) {
      const title = this.setPlanclassesName(this.$route.query.planclassesName)
      // console.log('1')
      this.setMetaTitle(title)
    }
    this.getInfo()
  },
  watch: {
    'list.planclassesName'(val) {
      if (this.$route.query.planclassesName || this.$route.name === 'gradeDetail') return
      let name = ''
      if (val) {
        name = val.length <= 30 ? val : `${val.substr(0, 29)}...`
      }
      console.log('2', this.$route.meta)
      name && this.setMetaTitle(name)
      // this.$route.meta.title = name
    },
    'planclassesId'(old, val) {
        console.log(old, val)
        if (old !== val) this.getInfo(val)
    }
    // $route(to, from) {
    //   // 这个地方是为了固定第一级目录是首页不变
    //   // if (matched.length && matched[0].name !== 'home') {
    //   //   matched = [{ path: '/home', name: 'home', meta: { title: '首页' } }, ...matched]
    //   // }
    //   this.$route.matched.forEach(item => {
    //     if (item.name === 'gradeDetail') {
    //       if (this.$route.query.planclassesName) {
    //         item.meta.title = this.$route.query.planclassesName
    //       } else {
    //         Reflect.deleteProperty(item.meta, 'title')
    //       }
    //     }
    //   })
    // }
  },
  beforeRouteLeave (to, from, next) {
    // ...
    // console.log('to', to)
    // console.log('from', from)
    // 离开班级路由时，清除班级路由的meta的title
      // console.log('3')
    this.setMetaTitle('')
    next()
  },
  methods: {
    setMetaTitle(title) {
      // console.log('title', title)
      // if (!title) {
      //   this.$route.matched.find(item => {
      //     if (item.name === 'gradeDetail') {
      //       // item.meta.title = title
      //       Reflect.deleteProperty(item.meta, 'title')
      //       console.log('item.meta', item.meta)
      //     }
      //   })
      //   return
      // }
      this.$route.matched.forEach(item => {
        if (item.name === 'gradeDetail') {
          if (title) {
            // console.log('title', title)
            item.meta.title = title
            item.meta.query = {
              planclassesId: this.planclassesId,
              planclassesName: title
            }
            // this.$route.meta.title = title
          } else {
            Reflect.deleteProperty(item.meta, 'title')
          }
        }
      })
      // console.log(this.$route)
    },
    setPlanclassesName(name = '') {
      if (name) {
        return name.length <= 30 ? name : `${name.substring(0, 29)}...`
      } else {
        return '班级名称'
      }
    },
    toLiveCalendar() {
      this.$router.push({ name: 'liveCalendar', query: { planclassesId: this.planclassesId, ocode: Vue.ls.get('code') } })
    },
    toLivePlay(item) {
      console.log(item)
      if (item.liveScheduleList && item.liveScheduleList.length) {
        const id = item.liveScheduleList[0].id
        goToLivePlayer(id, item.planclassesId)
      }
    },
    getInfo() {
      console.log('this.planclassesId', this.planclassesId)
      studentPlanclasses({ planclassesId: this.planclassesId }).then((res) => {
        this.list = res
        // console.log('this.$route', this.$route)
        // this.$route.meta.title = this.list.planclassesName
        // console.log(this.list.planclassesName)
        // console.log('mate', this.$route.meta.title)
      })
    },
    sortTabsChange(item) {
      if (item.value === 2) {
        this.list.subjectList.forEach(el => {
            console.log(el.classesList)
            el.classesList.sort((a, b) => this.comparedate(a, b))
        })
      }
      // item.value == 2 && this.list.subjectList.sort((a, b) => this.comparedate(a, b))
      item.value === 1 && this.getInfo()
      this.activeSortTab = item.value
    },
    // 计算两个时间的差值找到离当前时间最近的时间
    comparedate (obj1, obj2) {
       console.log(obj1, obj2)
       const currentdate = new Date()// 指定目标时间为当前时间
       const nowdate = currentdate.getTime() + currentdate.getTimezoneOffset() * 60000 // 我这里使用utc时间进行计算，请不要使用任何的utc转换计算方式，因为js会自动转为当前时间
        var val1 = new Date(obj1.lastWatchTime) // 2018-7-11 10:50:29
        var val2 = new Date(obj2.lastWatchTime)
        var dc1 = Math.abs((parseInt(nowdate - val1) / 1000))
        var dc2 = Math.abs((parseInt(nowdate - val2) / 1000))
        if (dc1 < dc2) {
            return -1
        } else if (dc1 > dc2) {
            return 1
        } else {
            return 0
        }
    },
    goToClassDetail(i, type) {
      this.$router.push({
        name: 'myClassDetail',
        query: {
          planclassesId: this.planclassesId,
          classesId: i.id,
          type: type,
        },
      })
    },
    goToClassMock(i) {
      console.log(i.courseDetailType)
      const type = i.classesType ? i.classesType : i.courseDetailType
      Vue.ls.set('classesType', type)
      const newLink = this.$router.resolve({ name: 'myAddition',
        query: {
          planclassesId: this.planclassesId,
          classesId: i.id
        },
        })
        window.open(newLink.href, '_blank')
    },
  },
}
</script>
<style scoped lang="less">
.main-body {
  width: 1200px;
  margin: 0 auto;
  // background: #f5f6fa;
}
.workplace_card {
  width: 100%;
  height: 272px;
  display: flex;
  align-items: center;
  // background: red;
}
.img {
  width: 300px;
  height: 100%;
}
.text {
  width: 500px;
  height: 100%;
}
.btn {
  width: 500px;
  height: 100%;
}
.content {
  .list-item {
    & > div {
      margin-bottom: 10px;
    }
    // height: 147px;
    padding: 20px;
    color: #5e668d;
    background: #ffffff;
    // box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
  }
  .course-badge {
    color: #fff;
    border-radius: 2px;
    padding: 0 2px;
    font-size: 12px;
    width: 52px;
  }
  .nearly {
    background-color: #ff1536;
  }
  .progress {
    width: 60%;
  }
  .img-wrapper {
    width: 35px;
    height: 35px;
    background-color: red;
    margin-right: 10px;
    border-radius: 50%;
    overflow: hidden;
  }
  .icon-img {
    width: 15px;
    height: 15px;
  }
}
.list-content {
  .list-item {
    & > div {
      margin-bottom: 10px;
    }
    width: 100%;
    height: 190px;
    padding: 20px;
    color: #5e668d;
    background: #ffffff;
    box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
  }
  .course-badge {
    color: #fff;
    border-radius: 2px;
    padding: 0 2px;
    font-size: 12px;
  }
  .nearly {
    background-color: #ff1536;
  }
  .progress {
    width: 60%;
  }
  .img-wrapper {
    width: 35px;
    height: 35px;
    background-color: red;
    margin-right: 10px;
    border-radius: 50%;
    overflow: hidden;
  }
  .icon-img {
    width: 15px;
    height: 15px;
  }
}
.list {
  padding: 20px;
  color: #5e668d;
  background: #ffffff;
  // box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  margin-bottom: 26px;
}
.line {
  height: 30px;
  width: 5px;
  background: #1890ff;
}
.img {
  width: 194px;
  // height: 300px;
  // background-image: url(~@/assets/login_back.png);
}
.tab-item {
  padding: 0 15px;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}
.tab-item-acitve {
  border-radius: 50px;
  background-color: #1564ff;
  color: #fff;
  overflow: hidden;
}
.living-icon {
  width: 10px;
  height: 10px;
}
</style>
